import { render, staticRenderFns } from "./traceHistogram.vue?vue&type=template&id=a8807124&scoped=true&"
import script from "./traceHistogram.vue?vue&type=script&lang=js&"
export * from "./traceHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8807124",
  null
  
)

export default component.exports